import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'

import { SearchContext, SEARCH } from '../search/SearchContext'
import { isBookingAgentAndisBookingAnUpgrade } from '../helpers/userHelper'
import { Button } from '../common/forms'

const HotelQualifiedQuestionsForm = (
  { successHandler,
    cancelHandler,
    tourOperatorNotes,
    setTourOperatorNotes
  }) => {
  const { state, dispatch } = useContext(SearchContext)
  const [selectedParent, setSelectedParent] = useState(null)
  const [cachedSelectedChildrenIds, setCachedSelectedChildrenIds] = useState([])
  const [selectedChildren, setSelectedChildren] = useState([])
  const [valid, setValid] = useState(false)

  const _setSelectedQualifyingQuestion = (payload) =>
    dispatch({ type: SEARCH.SELECTED_QUALIFYING_QUESTIONS.SET, payload: payload  })


  useEffect(() => {
    // Set as valid if no qualifying questions
    setValid(state.qualifyingQuestions.length == 0)
  }, [])

  const _toggleParentQuestion = (e, question) => {
    e.preventDefault()
    if (question.id != selectedParent) {
      setSelectedParent(question.id)
      setCachedSelectedChildrenIds(question.children.map(child => child.id).sort())
      setSelectedChildren([])
      if (question.children.length == 0) {
        setValid(true)
        _setSelectedQualifyingQuestion(question.id)
      } else {
        setValid(false)
      }
    }
  }

  const _toggleChildQuestion = (e, question) => {
    e.preventDefault()
    let newSelectedChildren = [...selectedChildren]
    const index = newSelectedChildren.indexOf(question.id)
    if (index > -1) {
      // remove
      newSelectedChildren.splice(index, 1)
    } else {
      newSelectedChildren.push(question.id)
      newSelectedChildren.sort()
    }
    setSelectedChildren(newSelectedChildren)
    if (isEqual(cachedSelectedChildrenIds, newSelectedChildren)) {
      setValid(true)
      _setSelectedQualifyingQuestion(selectedParent)
    } else {
      setValid(false)
      _setSelectedQualifyingQuestion(null)

    }
  }

  const _submitHandler = (e) => {
    if (e)
      e.preventDefault()

    if (!valid) return

    successHandler()
  }

  const _renderQualifiedQuestions = () => {
    return state.qualifyingQuestions.filter(question => !question.parent_id).map((qualifiedQuestion, index) => {
      return (
        <React.Fragment key={qualifiedQuestion.id}>
          <div className="interactive rows rooms">
            <button
              className={`row room check-box ${selectedParent == qualifiedQuestion.id ? 'selected' : ''}`}
              onClick={(e) => _toggleParentQuestion(e, qualifiedQuestion)}
            >
              <span className="name qualification-text no-flex" dangerouslySetInnerHTML={{__html: qualifiedQuestion.question_text}} />
            </button>
          </div>
          {_renderQualifiedQuestionChildren(qualifiedQuestion)}
        </React.Fragment>
      )
    })
  }

  const _renderQualifiedQuestionChildren = (qualifiedQuestion) => {
    if (qualifiedQuestion.children.length < 1 || selectedParent != qualifiedQuestion.id) {
      return null
    }

    const childrenQuestions = qualifiedQuestion.children.map((childQuestion, index) => {
      return (
        <div key={childQuestion.id} className="interactive rows rooms child">
          <button
            className={`row room check-box ${selectedChildren.includes(childQuestion.id) ? 'selected' : ''}`}
            onClick={(e) => _toggleChildQuestion(e, childQuestion)}
          >
            <span className="name qualification-text no-flex" dangerouslySetInnerHTML={{__html: childQuestion.question_text}} />
          </button>
        </div>
      )
    })

    return (
      <React.Fragment>
        {childrenQuestions}
      </React.Fragment>
    )
  }

  const _handleNotesOnChange = (e) => setTourOperatorNotes(e.target.value)

  const _renderNotesField = () => {
    if (isBookingAgentAndisBookingAnUpgrade(state)) {
      return
    }
    return (
      <div className="tour-operator notes fieldset">
        <h3>Notes</h3>
        <label>
          <textarea
            name="notes"
            className="tour-operator-notes"
            placeholder="Gifts, Special Requests, etc."
            value={tourOperatorNotes}
            onChange={_handleNotesOnChange}>
            </textarea>
        </label>
      </div>
    )
  }

  return (
    <form onSubmit={_submitHandler}>
      <h3>Qualifying Questions:</h3>
      <p className="thin-p">Almost there... check the boxes to make sure your guest qualifies.</p>

      {_renderQualifiedQuestions()}

      { _renderNotesField() }

      <Button
        className="secondary"
        clickHandler={_submitHandler}
        aria-label="Submit Form"
        disabled={!valid}
      >
        Continue
      </Button>

      {cancelHandler && (
        <Button
          className="cancel"
          clickHandler={cancelHandler}
          aria-label="Cancel Form"
        >
          Cancel
        </Button>
      )}
    </form>
  )
}

HotelQualifiedQuestionsForm.propTypes = {
  successHandler: PropTypes.func,
  cancelHandler: PropTypes.func,
  tourOperatorNotes: PropTypes.string,
  setTourOperatorNotes: PropTypes.func
}

export default HotelQualifiedQuestionsForm
